/* ═══════════════════════════════════════════════════════════════════
   DG ANIMATIONS — GSAP ScrollTrigger Integration
   ThemeDGCore | Distribution Gauthier
   ═══════════════════════════════════════════════════════════════════ */

(function () {

    /* ── Named init function — allows re-execution on shopify:section:load ── */
    function initAnimations() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            console.warn('GSAP or ScrollTrigger not loaded. Animations disabled.');
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        // 1. Fade up section headers
        const sectionHeaders = document.querySelectorAll('.dg-home__header, .dg-fp-header');
        sectionHeaders.forEach((header) => {
            gsap.fromTo(header,
                { y: 30, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.8,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: header,
                        start: 'top 85%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        });

        // 2. Staggered fade up for product cards in grids
        const grids = document.querySelectorAll('.dg-products-grid');
        grids.forEach((grid) => {
            const items = grid.querySelectorAll('.dg-products-grid__item');
            if (items.length > 0) {
                gsap.fromTo(items,
                    { y: 40, opacity: 0 },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.8,
                        stagger: 0.1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: grid,
                            start: 'top 80%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });

        // 3. Staggered fade up for Category Cards
        const catGrids = document.querySelectorAll('.dg-cats-grid, .dg-cats-grid--auto');
        catGrids.forEach((grid) => {
            const cards = grid.querySelectorAll('.dg-cat-card, .dg-cat-hero');
            if (cards.length > 0) {
                gsap.fromTo(cards,
                    { y: 40, opacity: 0 },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.8,
                        stagger: 0.1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: grid,
                            start: 'top 80%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });

        // 4. "How it Works" Steps stagger
        const stepsContainers = document.querySelectorAll('.dg-hiw__steps');
        stepsContainers.forEach((container) => {
            const steps = container.querySelectorAll('.dg-hiw__step');
            if (steps.length > 0) {
                gsap.fromTo(steps,
                    { y: 30, opacity: 0 },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.8,
                        stagger: 0.15,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: container,
                            start: 'top 75%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });

        // 5. "Promises" stagger
        const promisesGrid = document.querySelectorAll('.dg-promise__inner');
        promisesGrid.forEach((grid) => {
            const promises = grid.querySelectorAll('.dg-promise__item');
            if (promises.length > 0) {
                gsap.fromTo(promises,
                    { y: 30, opacity: 0 },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.8,
                        stagger: 0.1,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: grid,
                            start: 'top 85%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });

        // 6. Testimonials Stagger
        const testimonialGrids = document.querySelectorAll('.dg-testimonials-track-wrap');
        testimonialGrids.forEach((grid) => {
            const tests = grid.querySelectorAll('.dg-testimonial-card');
            if (tests.length > 0) {
                gsap.fromTo(tests,
                    { scale: 0.95, opacity: 0, y: 30 },
                    {
                        scale: 1,
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        stagger: 0.1,
                        ease: 'back.out(1.2)',
                        scrollTrigger: {
                            trigger: grid,
                            start: 'top 80%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });

        ScrollTrigger.refresh();
    }

    /* ── Page load — registered once, outside initAnimations ── */
    window.addEventListener('load', function () {
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    });

    /* ── Initial run ── */
    document.addEventListener('DOMContentLoaded', initAnimations);

    /* ── Theme editor lifecycle hooks ──────────────────────────────────
       shopify:section:load   — re-init animations for the updated section
       shopify:section:unload — kill all triggers before section is removed
       These events fire ONLY in the Shopify theme editor, never on the live store.
    ─────────────────────────────────────────────────────────────────── */
    document.addEventListener('shopify:section:load', function () {
        if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.getAll().forEach(function (st) { st.kill(); });
        }
        initAnimations();
    });

    document.addEventListener('shopify:section:unload', function () {
        if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.getAll().forEach(function (st) { st.kill(); });
        }
    });

})();

